import PropTypes from 'prop-types';
import React from 'react';
import { ActionSheet } from 'components/v3';
import { brand } from '../shared/brand';

// Phone confirm for the builder header's status chip (design: ConfirmSheet).
// Live → "Switch to Draft"; Draft → "Go Live", or "Save & go live" when
// there are unsaved edits. onConfirm(nextStatus); the parent closes it.
const LiveConfirmSheet = ({ open, status, dirty, onConfirm, onClose }) => {
  const appName = brand().name;
  const isLive = status === 'live';

  const items = isLive
    ? [{ key: 'draft', label: 'Switch to Draft', icon: 'power', danger: true }]
    : [
        {
          key: 'live',
          label: dirty ? 'Save & go live' : 'Go Live',
          icon: 'circle-check',
          primary: true,
        },
      ];

  return (
    <ActionSheet
      open={open}
      onClose={onClose}
      title={isLive ? 'This form is Live' : 'This form is a Draft'}
      subtitle={
        isLive
          ? `People can find it and submit entries in the ${appName} app.`
          : `It is hidden in the ${appName} app until you go live.`
      }
      items={items}
      onSelect={(key) => onConfirm(key)}
    />
  );
};

LiveConfirmSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  status: PropTypes.oneOf(['live', 'draft']).isRequired,
  dirty: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

LiveConfirmSheet.defaultProps = {
  dirty: false,
};

export default LiveConfirmSheet;
